export const normalizeString = (str: string): string => str.toString().replaceAll('-', '').toLocaleUpperCase();

const snakeToCamel = (str: string) => {
    return str.replace(/([-_]\w)/g, (matches) => matches[1].toUpperCase());
};

export const queryParamsToObject = (query: URLSearchParams) => {
    const obj: Record<string, string> = {};
    for (const [key, value] of query) {
        obj[snakeToCamel(key)] = value;
    }
    return obj;
};

export const normalizeLicensePlate = (licensePlate: string | undefined) =>
    (licensePlate || '').toLocaleLowerCase().replaceAll('-', '').trim();

/** When `showVehicleInternalId` is true and `internalId` is set, shows `{plate} ({internalId})`. */
export const formatLicensePlateWithInternalId = (
    licensePlate: string | undefined | null,
    internalId: string | number | null | undefined,
    showVehicleInternalId: boolean,
): string => {
    const plate = licensePlate ?? '';
    if (
        !showVehicleInternalId ||
        internalId === null ||
        internalId === undefined ||
        internalId === '' ||
        normalizeLicensePlate(internalId.toString().trim()) === normalizeLicensePlate(plate.toString().trim())
    ) {
        return plate;
    }
    return `${plate} (${internalId})`;
};

export const normalizeName = (driverName: string) => driverName.toLocaleLowerCase().trim();

export const formatPhoneNumber = (country: string, phoneNumber: string, removeCountryCode = false) => {
    if (phoneNumber === '') {
        return '';
    }
    let formattedPhoneNumber = phoneNumber;
    if (country === 'il') {
        if (removeCountryCode) {
            formattedPhoneNumber = formattedPhoneNumber.replace('+972', '0');
        }
        return formattedPhoneNumber.replace(/\D+/g, '').replace(/(\d{3})(\d{7})/, '$1-$2');
    } else {
        if (removeCountryCode) {
            formattedPhoneNumber = formattedPhoneNumber.replace('+1', '');
        }
        return formattedPhoneNumber.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }
};

export const unformatPhoneNumber = (phoneNumber: string) => {
    return phoneNumber.replace(/\D+/g, '');
};

export const b64DecodeUnicode = (str: string) => {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(
        atob(str)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join(''),
    );
};

export const uniq = (value: string | number, index: number, self: Array<string | number>): boolean => {
    return !!value && self.indexOf(value) === index;
};

export const localeSort = (a: string, b: string) => a.localeCompare(b);
